const PLUS = /\+/g;
const ENCODED_SLASH = /%2F/gi;

function decode(input: string) {
  let string = input.replace(PLUS, ' ');
  try {
    return decodeURIComponent(string);
  } catch (ex) {
    return unescape(string);
  }
}

function encode(input: string) {
  return encodeURIComponent(input).replace(ENCODED_SLASH, '/');
}

export function parse(input: string) {
  if (input.charAt(0) === '?' || input.charAt(0) === '#') {
    input = input.slice(1);
  }
  let result: ObjectOf<string> = {};
  let parts = input.split('&');
  for (let part of parts) {
    let pos = part.indexOf('=');
    if (pos < 0) {
      pos = part.length;
    }
    let key = decode(part.slice(0, pos));
    if (key) {
      let value = decode(part.slice(pos + 1));
      result[key] = value;
    }
  }
  return result;
}

export function stringify(params: ObjectOf<string>, prepend = '') {
  let parts: Array<string> = [];
  for (let [key, value] of Object.entries(params)) {
    parts.push(encode(key) + '=' + encode(value));
  }
  return parts.length ? prepend + parts.join('&') : '';
}
